import { Column } from '../signature-table.types';

export const allSignaturesColumnsConfig = {
  stickyColumns: [Column.DOCUMENT_NAME] as Column[],
  scrollableColumns: [
    Column.CATEGORY,
    Column.STATUS,
    Column.SIGNATORIES,
    Column.LAST_SENT,
    Column.EXPIRY,
    Column.ACTIONS,
  ] as Column[],
  sortableColumns: [Column.DOCUMENT_NAME, Column.LAST_SENT, Column.EXPIRY] as Column[],
} as const;
